import { apiRequest } from '../../../api/client';
import type { BillingDto, CheckoutSessionResponseDto, PortalSessionResponseDto } from '../types/billing';

export function getBilling(customerId: string): Promise<BillingDto> {
  return apiRequest<BillingDto>(`/v1/customers/${encodeURIComponent(customerId)}/billing`);
}

export function createCheckoutSession(customerId: string): Promise<CheckoutSessionResponseDto> {
  return apiRequest<CheckoutSessionResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/billing/checkout-session`, {
    method: 'POST',
  });
}

export function createPortalSession(customerId: string): Promise<PortalSessionResponseDto> {
  return apiRequest<PortalSessionResponseDto>(`/v1/customers/${encodeURIComponent(customerId)}/billing/portal-session`, {
    method: 'POST',
  });
}
